import {
  ICONS,
  IconType,
  IToastSettings,
  ToastTypeEnum,
} from '@aksia/infrastructure';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  input,
  OnInit,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'toast',
  imports: [IconComponent],
  templateUrl: 'toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit {
  //#region Host Bindings

  @HostBinding('attr.uicontrol')
  uiControl = '';

  @HostBinding('class') get class() {
    return `${
      this.settings()?.useDynamicInjection
        ? (this.settings()?.position ?? 'bottom-right')
        : ''
    } ${this.settings()?.pinned ? 'pinned' : ''}`;
  }

  @HostListener('click', ['$event'])
  click(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
  }

  //#endregion

  //#region Constants

  protected readonly ICONS = ICONS;

  //#endregion

  //#region Inputs/Outputs

  settings = input<IToastSettings>();

  //#endregion

  //#region Properties

  protected cssClass = '';
  protected icon?: IconType;

  //#endregion

  //#region Functions

  ngOnInit(): void {
    switch (this.settings()?.type) {
      case ToastTypeEnum.Success: {
        this.icon = ICONS.CHECK_CIRCLE;
        this.cssClass = 'toast-success';
        break;
      }
      case ToastTypeEnum.Warning: {
        this.icon = ICONS.WARNING;
        this.cssClass = 'toast-warning';
        break;
      }
      case ToastTypeEnum.Error: {
        this.icon = ICONS.WARNING;
        this.cssClass = 'toast-error';
        break;
      }
      default: {
        this.icon = ICONS.INFO;
        this.cssClass = 'toast-info';
        break;
      }
    }
  }

  //#endregion
}
